var render = function render(){var _vm=this,_c=_vm._self._c;return _c('price-board',{model:{value:(_vm.createPriceComponentData),callback:function ($$v) {_vm.createPriceComponentData=$$v},expression:"createPriceComponentData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }